import videojs from 'video.js'
const Component = videojs.getComponent('Component')
const PlaybackRateMenuItem = videojs.getComponent('PlaybackRateMenuItem')

class NFBPlayback extends Component {

  constructor(player) {
    super(player)
    this.buildPlaybackMenu()
  }

  buildPlaybackMenu() {
    let playbackContainer = document.createElement('div')
    playbackContainer.classList.add('nfb-settings-panel__items-container')
    playbackContainer.setAttribute('data-ui-el', 'settings-panel-playback')
    playbackContainer.setAttribute('data-cy', 'settings-panel-playback')
    playbackContainer.innerHTML = `<span class="nfb-settings-panel__item-title">${this.player().localize('Playback Rate')}</span>`
    this.player().el().querySelector('[data-ui-el="settings-panel"]').prepend(playbackContainer)

    const playbackRates = this.player().playbackRates()
    playbackRates.forEach((playbackRate) => {
      let playbackItem = new PlaybackRateMenuItem(this.player(), {rate: playbackRate + 'x'})
      playbackItem.el().classList.add('nfb-settings-panel__item')
      playbackItem.el().setAttribute('tabindex', '0')
      playbackContainer.appendChild(playbackItem.el())
    })
  }
}

videojs.registerComponent('NFBPlayback', NFBPlayback);
